import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import SectionHeading from "@/components/base/SectionHeading";
import CompanySubNav from "@/pages/company/components/CompanySubNav";
import PortraitImage from "@/components/base/PortraitImage";
import { withBase } from "@/constants/site";

export default function CompanyMessage() {
  return (
    <div className="w-full bg-background-50">
      <PageHero
        en="MESSAGE"
        ja="代表挨拶"
        crumbs={[{ label: "企業情報", path: "/company" }, { label: "代表挨拶" }]}
      />
      <CompanySubNav />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <SectionHeading label="創業者メッセージ" en="Founder Message" />
          </ScrollReveal>

          <div className="mt-14 grid grid-cols-1 gap-12 lg:grid-cols-[1fr_1.4fr] lg:gap-20">
            <ScrollReveal>
              <div className="lg:sticky lg:top-28">
                <p className="font-display text-2xl font-light leading-[1.9] tracking-[0.04em] text-foreground-950 md:text-3xl">
                  事業を創る会社ではなく、
                  <br />
                  人の可能性を創る会社です。
                </p>
                <div className="mx-auto mt-10 w-full max-w-xs md:max-w-sm lg:mx-0">
                  <PortraitImage
                    src={withBase("/images/message/founder.jpg")}
                    alt="創業者 山田 海大"
                    name="山田 海大"
                    role="FOUNDER"
                  />
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={150}>
              <div className="flex flex-col gap-6 font-body text-[15px] leading-[2.2] text-foreground-700">
                <p>
                  テクノロジーの進化や社会構造の変化により、世界はかつてないスピードで変わり続けています。
                  しかし、どれだけ時代が変わっても、変革を起こし、新しい時代を創るのは、
                  いつの時代も「人」だと私たちは信じています。
                </p>
                <p>
                  <strong className="font-medium text-foreground-950">REVRA Group</strong>の「REVRA」とは、
                  Revolution（変革）とEra（時代）を掛け合わせた言葉です。
                </p>
                <p>
                  私たちが本当に目指すのは、事業の成功ではなく、
                  一人ひとりの可能性が花開く社会を創ることです。
                  そのために、一人ひとりが挑戦し、自らの可能性を最大限に発揮できる環境を創り続けます。
                </p>
                <p className="font-display text-xl leading-[2] tracking-[0.04em] text-foreground-950">
                  人が挑戦し、成長する。
                </p>
                <p>
                  その挑戦が新たな価値を生み、やがて社会を変え、新しい時代を創っていく。
                  人を信じ、人に投資し、人が起こす変革で、新しい時代を創る。
                </p>
                <p className="font-display text-xl leading-[2] tracking-[0.04em] text-foreground-950">
                  それこそが、
                  <br />
                  我々REVRA Groupの使命です。
                </p>

                <div className="mt-10 flex flex-col gap-2 border-t border-background-300/70 pt-8">
                  <span className="font-label text-xs tracking-[0.3em] text-secondary-500">
                    REVRA GROUP / FOUNDER
                  </span>
                  <span className="font-heading text-2xl tracking-[0.06em] text-foreground-950">
                    山田 海大
                  </span>
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <section className="w-full bg-background-100 py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <SectionHeading label="代表メッセージ" en="Representative Message" />
          </ScrollReveal>

          <div className="mt-14 grid grid-cols-1 gap-12 lg:grid-cols-[1.4fr_1fr] lg:gap-20">
            <ScrollReveal>
              <div className="flex flex-col gap-6 font-body text-[15px] leading-[2.2] text-foreground-700">
                <p className="font-display text-2xl font-light leading-[1.9] tracking-[0.04em] text-foreground-950 md:text-3xl">
                  人の可能性に、限界はない。
                  <br />
                  私はそう信じています。
                </p>
                <p>
                  一人ではできないことも、同じ想いを持つ仲間が集まり、本気で挑戦すれば、
                  想像を超える価値を生み出すことができる。
                  だからREVRA Groupは、何よりも「ヒト」を大切にする会社でありたいと考えています。
                </p>
                <p>
                  働く仲間が仕事に誇りを持ち、成長を楽しみ、
                  「この会社で挑戦してよかった」と思えること。
                  その幸せや熱量が、お客様や取引先へと広がり、
                  さらに大きな価値になって社会へつながっていく。
                  私は、そんな会社をつくりたいと思っています。
                </p>
                <p>
                  時代が変われば、求められる価値も変わります。
                  だからこそ私たちは、今ある形にとらわれません。
                  変化を恐れず、新しいことに挑戦し、仲間と共に成長し続ける。
                  そして、REVRA Groupに関わる一人ひとりの可能性を、社会を動かす価値へと変えていく。
                </p>
                <p className="font-display text-xl leading-[2] tracking-[0.04em] text-foreground-950">
                  ヒトが価値を創り、ヒトが未来を変える。
                </p>
                <p>
                  共に挑み、共に成長し、共に未来を創る会社であり続けます。
                </p>

                <div className="mt-4 flex flex-col gap-2 border-t border-background-300/70 pt-8">
                  <span className="font-label text-xs tracking-[0.3em] text-secondary-500">
                    REVRA GROUP / REPRESENTATIVE DIRECTOR
                  </span>
                  <span className="font-heading text-2xl tracking-[0.06em] text-foreground-950">
                    河出 享一郎
                  </span>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={150} className="order-first lg:order-none">
              <div className="lg:sticky lg:top-28">
                <div className="mx-auto w-full max-w-xs md:max-w-sm lg:mr-0">
                  <PortraitImage
                    src={withBase("/images/message/representative.jpg")}
                    alt="代表取締役 河出 享一郎"
                    name="河出 享一郎"
                    role="REPRESENTATIVE DIRECTOR"
                  />
                </div>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>
    </div>
  );
}